import React from "react";
import "./Home.css";
import Typewriter from "typewriter-effect";
import love from "../../Image/Vector.png";
import MyCv from "./MyResume.pdf";
import { BsFillMoonStarsFill, BsSun } from "react-icons/bs";
import ball from "../../Image/Star1.png";
import { Link } from "react-scroll";

const Home = ({ theme, changeTheme }) => {
  return (
    <div className="container-fluid home" id="home">
      <div className="theme-change glass-panel" onClick={changeTheme}>
        {theme === "light" ? (
          <p>
            <BsFillMoonStarsFill size={20} />
          </p>
        ) : (
          <p className="sun-light-icon">
            <BsSun size={20} color="var(--accent-color)" />
          </p>
        )}
      </div>
      <div className="container home-content">
        <h1 className="hero-greeting">
          Hello <img className="hero-vector" alt="vector" src={love} />, I'm Ayobami
        </h1>

        <h2 className="hero-title gradient-text">
          <Typewriter
            options={{
              strings: [
                "Senior Mobile Developer",
                "Flutter Expert",
                "Software Engineer",
              ],
              autoStart: true,
              loop: true,
              delay: 50,
              deleteSpeed: 30,
            }}
          />
        </h2>
        
        <p className="hero-subtitle">
          Building scalable, high-performance mobile ecosystems.
        </p>

        <div className="button-for-action">
          <Link to="contact" className="hire-me-button primary-btn glass-panel">
            Hire Me
          </Link>
          <div className="get-resume-button">
            <a href={MyCv} download="Ayobami_cv" className="secondary-btn">
              Get Resume
            </a>
          </div>
        </div>

        <img className="baller float-animation" alt="balling" src={ball} />
      </div>
    </div>
  );
};

export default Home;
